export enum SetupVersion {
  Enable2fa,
  Disable2fa
}

export type SetupCompleteProps = {
  onFinish(): void
  setupVersion?: SetupVersion
}
